import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { correctURLToHttpsProtocol } from '../../utils/helpers/valid';

const BacklinkCard = ({
  _id,
  domain,
  categories,
  createdAt,
  isChecked,
  handleCheckboxChange,
  manage,
  handleDeleteBacklinks,
}) => {
  const [checked, setChecked] = useState(isChecked);

  const createdMoreThan30DaysAgo = new Date(createdAt) < new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
  const amountOfDaysPassed = Math.floor(
    (Date.now() - new Date(createdAt)) / (1000 * 60 * 60 * 24),
  );

  const handleCheckbox = () => {
    setChecked(!checked);
    handleCheckboxChange(_id, !checked);
  };

  return (
    <Card
      style={{
        border: checked ? '1px solid #005cd4' : '1px solid #ccc',
        cursor: 'pointer',
      }}
      onClick={handleCheckbox}
    >
      <Card.Body>
        <Card.Text
          style={{
            color: 'blue',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
          }}
        >
          <a href={correctURLToHttpsProtocol(domain)} target="_blank">
            {domain}
          </a>
          {!createdMoreThan30DaysAgo && <span>
            {amountOfDaysPassed ? `חדש, נוצר לפני ${amountOfDaysPassed} ימים` : 'חדש'}
          </span>}
          {categories.length > 0 && (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
              }}
            >
              {categories.map(({ _id, name }) => (
                <span
                  key={_id}
                  style={{
                    fontSize: '0.6rem',
                    margin: '0.3rem',
                    padding: '0.5rem',
                    border: '1px solid #ccc',
                    borderRadius: '0.5rem',
                    backgroundColor: '#f5f5f5',
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: '0.1rem',
                  }}
                >
                  <span>{name}</span>
                </span>
              ))}
            </div>
          )}
        </Card.Text>
        <Card.Subtitle>
          <Form.Check
            style={{ width: 'fit-content' }}
            type="checkbox"
            id={`${domain}-checkbox`}
            label="בחר"
            checked={checked}
            onChange={handleCheckbox}
          />
        </Card.Subtitle>
        {manage && (
          <Card.Text
            style={{
              display: 'flex',
              justifyContent: 'left',
            }}
          >
            <Button
              variant="danger"
              onClick={() => handleDeleteBacklinks([_id])}
            >
              מחק
            </Button>
          </Card.Text>
        )}
      </Card.Body>
    </Card>
  );
};

export default BacklinkCard;
